import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountTemplateList } from '../models/state-export-account';

@Injectable()
export class StateExportAccountTemplateService {
	endpoint = '/api/stateExportAccountTemplate';

	constructor(private $http: HttpClient) {}

	getNumberOfTemplates(search) {
		return this.$http.get(this.endpoint + '/numberOfTemplates', {
			params: { search },
		});
	}

	getTemplatesByPage(search, pageSize, startIndex) {
		return this.$http.get(this.endpoint + '/getTemplatesByPage', {
			params: { search, pageSize, startIndex },
		});
	}

	getPageIndexForTemplate(search, pageSize, startIndex, templateId) {
		return this.$http.get(this.endpoint + '/getPageIndexForTemplate', {
			params: {
				search,
				pageSize,
				startIndex,
				templateId,
			},
		});
	}

	getMappingTemplates(): Observable<AccountTemplateList> {
		return this.$http.get<AccountTemplateList>(this.endpoint + '/getMappingTemplates');
	}

	addEditTemplate(template) {
		return this.$http.post(this.endpoint + '/addEdit', template);
	}

	deleteMappingTemplate(template) {
		return this.$http.post(this.endpoint + '/deleteTemplate', template);
	}

	getTemplate(id) {
		return this.$http.get(this.endpoint + '/getTemplate', { params: { Id: id } });
	}

	getNumberOfAccounts(accountTypeIds, search, excludeMapped) {
		const accountPaging = {
			AccountTypeIds: accountTypeIds,
			Search: search,
			ExcludeMapped: excludeMapped,
		};
		return this.$http.post('api/account/numberOf', accountPaging);
	}

	getAccountsByPage(accountTypeIds, search, pageSize, startIndex, excludeMapped) {
		const accountPaging = {
			AccountTypeIds: accountTypeIds,
			Search: search,
			ExcludeMapped: excludeMapped,
			PageSize: pageSize,
			StartIndex: startIndex,
		};
		return this.$http.post('api/account/getByPage', accountPaging);
	}

	getAccountsForSelectAndUnSelectAll(accountTypeIds, search, excludeMapped, selected) {
		return this.$http.get(this.endpoint + '/getAccountsForSelectAndUnSelectAll', {
			params: {
				accountTypeIds,
				search,
				excludeMapped,
				selected,
			},
		});
	}
}
